import { Layout, locale, util } from '@glu/core';
import dialog from '@glu/dialog';
import ListBuilder from '@glu/list-builder';

import template from './manageDialogLayout.hbs';

export default Layout.extend({
  template,
  modalClass: 'manage-multi-sort-dialog',
  regions: {
    listBuilder: '.region-list-builder'
  },
  initialize() {
    this.sortedColumnsCollection = this.options.sortedColumnsCollection;
    this.selectedColumnsCollection = this.selectedColumnsCollection || this.options.targetCollection;
  },
  onRender() {
    this.tempSource = this.sortedColumnsCollection.clone();
    this.tempTarget = this.selectedColumnsCollection.clone();
    this.listBuilder.show(this.createListBuilder());
  },
  onShow() {
    this.toggleApplyButton();
  },
  onClose() {
    if (!this.manage) {
      this.options.view.toggleSwitch(false);
    }
  },
  dialogTitle() {
    return this.options.dialogTitle;
  },
  dialogButtons: [{
    text: locale.get('apply'),
    className: 'btn-primary',
    callback: 'applySort'
  }, {
    text: locale.get('cancel'),
    className: 'btn-default',
    callback() {
      dialog.close();
    }
  }],
  createListBuilder() {
    const listBuilderOptions = util.extend({
      dataPersist: true,
      sourceCollection: this.tempSource,
      targetCollection: this.tempTarget
    }, this.options.listBuilderOptions);

    const listBuilder = new ListBuilder(listBuilderOptions);

    this.listenTo(listBuilder, 'targetListUpdated', this.toggleApplyButton);

    return listBuilder;
  },
  setManage(manage) {
    this.manage = manage;
  },
  toggleApplyButton() {
    this.$el.parent().next('.modal-footer').find('.btn-primary').prop('disabled', (!this.tempTarget.length && !this.manage));
  },
  applySort() {
    if (this.tempTarget.length > 0) {
      this.sortedColumnsCollection = this.tempSource;
      this.selectedColumnsCollection = this.tempTarget;
      this.options.view.applyMultiColumnSort(this.tempTarget.clone());
      this.setManage(true);
    } else {
      this.setManage(false);
    }

    dialog.close();
  }
});
